<template>
    <Dashboard
        :title="__('Create review', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Create review', null, $page.props.profile_locale)"
            :description="'<span class=\'text-red-700\'>' + product.name + '</span>'"
            :backLink="route('dashboard.admin.product.reviews', product.id)"
        />

        <div class="grid lg:grid-cols-2 gap-3">
            <InputLabel
                id="name"
                :label="__('Name', null, $page.props.profile_locale)"
                v-model="form.name"
            />
            <InputLabel
                id="addons"
                :label="__('Aditional info', null, $page.props.profile_locale)"
                v-model="form.addons"
            />
            <InputLabel
                id="content"
                type="textarea"
                rows="5"
                :label="__('Contents', null, $page.props.profile_locale)"
                v-model="form.content"
            />

            <div class="lg:col-span-2 flex justify-start">
                <Button
                    color="gray"
                    padding="md"
                    @click="save()"
                >
                {{__('Save', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Dashboard,
        Heading,
        InputLabel,
        Button
    },
    props: ['product', 'review'],
    setup(props) {

        const form = useForm({
            name: props.review ? props.review.name : '',
            addons: props.review ? props.review.addons : '',
            content: props.review ? props.review.content : '',
            product_id: props.product.id,
        });


        function save() {
            form.post(route('product.review.' + (props.review ? 'update' : 'store'), props.review ? props.review.id : ''), {
                preserveScroll: true,
                onSuccess: () => { if(!props.review) form.reset() },
            })
        }

        return {
            form,

            save
        }
    }
}
</script>

<style>

</style>
